<div class="novedades-card">
  <div class="novedades-header">
    <h5 class="novedades-title">Novedades</h5>
    <button mat-icon-button color="primary" (click)="agregarNovedad()" matTooltip="Agregar novedad">
      <mat-icon>add_circle</mat-icon>
    </button>
  </div>

  <div *ngIf="loading" class="text-center my-3">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div *ngIf="!hayError && !loading && (!novedades || novedades.length === 0)" class="empty-state">
    No hay novedades disponibles.
  </div>

  <div *ngIf="hayError && !loading && (!novedades || novedades.length === 0)" class="empty-state">
    Ocurrió un error al recuperar las novedades.
  </div>

  <ul *ngIf="!loading && novedades && novedades.length > 0" class="novedades-list">
    <li *ngFor="let novedad of novedades" class="novedad-item">
      <div class="novedad-header">
        <div class="novedad-fecha-chip">
          {{ novedad.fechaPublicacion | date:'dd/MM/yyyy' }}
        </div>
        <div class="novedad-actions">
          <button mat-icon-button color="primary" (click)="editarNovedad(novedad)" matTooltip="Editar">
            <mat-icon class="action-icon">edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="eliminarNovedad(novedad)" matTooltip="Eliminar">
            <mat-icon class="action-icon delete-icon">delete</mat-icon>
          </button>
        </div>
      </div>
      <div class="novedad-content" [innerHTML]="novedad.texto | safeHTML"></div>
    </li>
  </ul>
</div>